// extracted by mini-css-extract-plugin
module.exports = {"container":"CardFooter_container__2I22J","description":"CardFooter_description__3x24J","icon":"CardFooter_icon__1k-Ig"};